import { Component } from '@angular/core';

@Component({
  selector: 'mms-admin',
  templateUrl: './mms-admin.component.html',
  standalone: false,
})
export class MmsAdmin {}
